import React, { useState, useEffect } from 'react';
import { getLoginLogs, getOperationLogs } from './adminApi';
import './Logs.css';

const Logs = ({ type = 'login' }) => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({ page: 1, page_size: 20, total: 0 });
  const [filters, setFilters] = useState({
    username: '',
    status: '',
    action: '',
    start_date: '',
    end_date: ''
  });

  useEffect(() => {
    fetchLogs();
  }, [pagination.page, type]);

  const fetchLogs = async () => {
    try {
      setLoading(true);
      const params = { page: pagination.page, page_size: pagination.page_size };
      
      if (filters.username) params.username = filters.username;
      if (filters.status) params.status = filters.status;
      if (filters.action) params.action = filters.action;
      if (filters.start_date) params.start_date = filters.start_date;
      if (filters.end_date) params.end_date = filters.end_date;

      const result = type === 'login' 
        ? await getLoginLogs(params)
        : await getOperationLogs(params);
      
      setLogs(result.items);
      setPagination(prev => ({ ...prev, total: result.total }));
    } catch (err) {
      console.error('获取日志失败:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setPagination(prev => ({ ...prev, page: 1 }));
    fetchLogs();
  };

  const totalPages = Math.ceil(pagination.total / pagination.page_size);

  return (
    <div className="logs-page">
      <div className="page-header">
        <h2 className="page-title">{type === 'login' ? '登录日志' : '操作日志'}</h2>
      </div>

      {/* 搜索和筛选 */}
      <div className="admin-card">
        <form className="admin-search-bar" onSubmit={handleSearch}>
          <input
            type="text"
            className="admin-search-input"
            placeholder="搜索用户名..."
            value={filters.username}
            onChange={(e) => setFilters({ ...filters, username: e.target.value })}
          />
          {type === 'login' && (
            <select
              className="admin-select"
              style={{ width: 'auto' }}
              value={filters.status}
              onChange={(e) => setFilters({ ...filters, status: e.target.value })}
            >
              <option value="">全部状态</option>
              <option value="success">成功</option>
              <option value="failed">失败</option>
            </select>
          )}
          {type === 'operation' && (
            <select
              className="admin-select"
              style={{ width: 'auto' }}
              value={filters.action}
              onChange={(e) => setFilters({ ...filters, action: e.target.value })}
            >
              <option value="">全部操作</option>
              <option value="user.create">创建用户</option>
              <option value="user.update">更新用户</option>
              <option value="user.delete">删除用户</option>
              <option value="user.reset_password">重置密码</option>
              <option value="role.create">创建角色</option>
              <option value="role.update">更新角色</option>
              <option value="role.delete">删除角色</option>
              <option value="setting.update">更新设置</option>
              <option value="announcement.create">创建公告</option>
              <option value="announcement.delete">删除公告</option>
            </select>
          )}
          <input
            type="date"
            className="admin-input"
            style={{ width: 'auto' }}
            value={filters.start_date}
            onChange={(e) => setFilters({ ...filters, start_date: e.target.value })}
            placeholder="开始日期"
          />
          <input
            type="date"
            className="admin-input"
            style={{ width: 'auto' }}
            value={filters.end_date}
            onChange={(e) => setFilters({ ...filters, end_date: e.target.value })}
            placeholder="结束日期"
          />
          <button type="submit" className="admin-btn admin-btn-primary">搜索</button>
        </form>
      </div>

      {/* 日志列表 */}
      <div className="admin-card">
        {loading ? (
          <div className="admin-loading"><div className="admin-loading-spinner"></div></div>
        ) : (
          <>
            <table className="admin-table">
              <thead>
                <tr>
                  {type === 'login' ? (
                    <>
                      <th>ID</th>
                      <th>用户名</th>
                      <th>登录时间</th>
                      <th>IP地址</th>
                      <th>状态</th>
                      <th>失败原因</th>
                    </>
                  ) : (
                    <>
                      <th>ID</th>
                      <th>用户名</th>
                      <th>操作</th>
                      <th>对象类型</th>
                      <th>对象ID</th>
                      <th>IP地址</th>
                      <th>时间</th>
                    </>
                  )}
                </tr>
              </thead>
              <tbody>
                {logs.map(log => (
                  <tr key={log.id}>
                    {type === 'login' ? (
                      <>
                        <td>{log.id}</td>
                        <td>{log.username}</td>
                        <td>{log.login_time}</td>
                        <td>{log.login_ip || '-'}</td>
                        <td>
                          <span className={`admin-tag ${log.login_status === 'success' ? 'admin-tag-success' : 'admin-tag-error'}`}>
                            {log.login_status === 'success' ? '成功' : '失败'}
                          </span>
                        </td>
                        <td>{log.failure_reason || '-'}</td>
                      </>
                    ) : (
                      <>
                        <td>{log.id}</td>
                        <td>{log.username}</td>
                        <td>{log.action}</td>
                        <td>{log.target_type || '-'}</td>
                        <td>{log.target_id || '-'}</td>
                        <td>{log.ip_address || '-'}</td>
                        <td>{log.created_at}</td>
                      </>
                    )}
                  </tr>
                ))}
                {logs.length === 0 && (
                  <tr>
                    <td colSpan={type === 'login' ? 6 : 7} className="admin-empty">暂无日志数据</td>
                  </tr>
                )}
              </tbody>
            </table>

            {/* 分页 */}
            {totalPages > 1 && (
              <div className="admin-pagination">
                <button 
                  disabled={pagination.page === 1}
                  onClick={() => setPagination(prev => ({ ...prev, page: prev.page - 1 }))}
                >
                  上一页
                </button>
                <span>第 {pagination.page} / {totalPages} 页</span>
                <button 
                  disabled={pagination.page === totalPages}
                  onClick={() => setPagination(prev => ({ ...prev, page: prev.page + 1 }))}
                >
                  下一页
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Logs;